import { Outlet } from '@tanstack/react-router'
import { Sidebar } from './Sidebar'
import { NotifPopup } from './NotifPopup'

export function AppShell() {
  return (
    <div className="flex h-screen w-screen overflow-hidden bg-ink-50">
      <Sidebar />
      <div className="flex flex-1 flex-col overflow-hidden">
        {/* Brand bar oscura encima del contenido */}
        <div className="flex h-10 shrink-0 items-center justify-between border-b border-white/10 bg-ink-950 px-6 text-[11px] font-medium text-ink-300">
          <span className="tracking-wide">Maz Autopartes · Panel administrativo</span>
          <span className="text-ink-400">v2.0.0-beta</span>
        </div>
        <main className="flex-1 overflow-y-auto pt-8">
          <Outlet />
        </main>
      </div>
      {/* Toaster global de notificaciones (SSE) — vive en todas las páginas del admin */}
      <NotifPopup />
    </div>
  )
}
